export default __webpack_public_path__ + "static/media/nalknad_aramane.73795df7.jpg";